// Course catalogue for Dickies-Campus
// Categories: einstieg | erfahren | fuehrung | pflicht

export const COURSE_LIST = [
  // EINSTIEG
  {
    id: 'ambulanter-pflegeassistent',
    category: 'einstieg',
    title: 'Ambulante Pflegeassistenz',
    subtitle: 'Grundlagen & Behandlungspflege LG1/LG2',
    duration: '300 UE + 3 Monate Praktikum',
    schedule: [
      'Mo–Fr · 09:00–13:00 Uhr',
      'Mo–Do · 18:00–20:00 Uhr (Abendkurs)',
      'Mo–Fr · 09:00–15:30 Uhr (Bildungsgutschein)',
    ],
    nextStart: 'Jeden Montag',
    weeks: '9 Wochen',
    format: 'E-Learning in deinem Tempo · ergänzt durch Live-Termine',
    price: '€ 2.390',
    funding: 'Bildungsgutschein möglich',
    audience: 'Einstieg – wenig oder keine Berufserfahrung',
    description: 'Dein direkter Einstieg in die ambulante Pflege mit anerkannter Qualifikation für Behandlungspflege LG1 & LG2. Du lernst alle Tätigkeiten, die du im Alltag der häuslichen Pflege wirklich brauchst – und kannst sofort höhere Leistungen abrechnen.',
    curriculum: [
      'Grundlagen der Pflege: Anatomie, Physiologie, Krankheitslehre',
      'Hygiene & Infektionsschutz nach KRINKO/RKI',
      'LG1 Behandlungspflege: Medikamentengabe, Blutdruck-/Blutzuckermessung, subkutane Injektionen, Kompressionsstrümpfe',
      'LG2 Behandlungspflege: Wundversorgung (Dekubitus bis Grad 2), Katheter- & Sondenpflege (SPK, PEG), Flüssigkeitsbilanzierung',
      'Grundlagen Wundversorgung',
      'Pflegedokumentation & rechtliche Grundlagen (SGB V, SGB XI)',
      'Kommunikation & Pflegeethik',
      'Notfallmaßnahmen & Erste Hilfe',
      'Praktikum: 3 Monate – zeitlich frei einteilbar (z. B. blockweise oder gestreckt)',
    ],
    outcomes: [
      'Anerkannte Qualifikation nach Landesrahmenvertrag NRW',
      'Sofort einsatzfähig in der ambulanten Pflege',
      'Mehr Verantwortung & höhere Abrechnungssätze',
    ],
  },
  {
    id: 'pflegehelfer-qn2',
    category: 'einstieg',
    title: 'Pflegeassistenz QN2',
    subtitle: 'Praxisnahes Basiswissen für die stationäre Pflege',
    duration: '429 UE + 40 Std. Praktikum',
    schedule: [
      'Mo–Fr · 09:00–13:00 Uhr',
      'Mo–Do · 18:00–20:00 Uhr (Abendkurs)',
      'Mo–Fr · 09:00–15:30 Uhr (Vollzeit)',
    ],
    nextStart: 'Jeden Montag',
    weeks: '14 Wochen',
    price: '€ 3.114,54',
    funding: 'Direktbuchung',
    audience: 'Einstieg – ausschließlich für den stationären Bereich (Pflegeheim, Kurzzeitpflege, Tagespflege)',
    description: 'Der ideale Einstieg in den stationären Pflegebereich. Du lernst alles, was du in der täglichen stationären Pflege brauchst – von der Grundpflege bis hin zu rechtlichen Grundlagen. Mit anerkanntem Zertifikat startest du sicher in Pflegeheimen, Tages- oder Kurzzeitpflege. (Hinweis: Diese Qualifikation ist ausschließlich für den stationären Bereich gedacht – für die ambulante Pflege empfehlen wir die „Ambulante Pflegeassistenz".)',
    curriculum: [
      'Grundpflege im stationären Setting: Körperpflege, Mobilisation, Lagerung',
      'Hygiene & Infektionsschutz im Heim',
      'Vitalzeichenkontrolle (Puls, Blutdruck, Temperatur, Atmung)',
      'Ernährungslehre & Hilfe bei der Nahrungsaufnahme',
      'Inkontinenzversorgung',
      'Pflegedokumentation nach Heim-Standards',
      'Grundlagen Demenz & Palliative Care',
      'Kommunikation mit Bewohnern und Angehörigen',
      'Erste Hilfe & Notfallsituationen',
      'Praktikum: 40 Std. in einer stationären Pflegeeinrichtung',
    ],
    outcomes: [
      'Zertifikat Pflegeassistenz QN2 für den stationären Bereich',
      'Direkt einsatzbereit in Pflegeheimen, Tages- & Kurzzeitpflege',
      'Grundlage für weiterführende stationäre Qualifikationen',
    ],
  },
  {
    id: 'pflegehilfskraft-betreuung',
    category: 'einstieg',
    title: 'Pflegehilfskraft & Betreuungsassistent',
    subtitle: 'Kombikurs §§43b, 53b, 53c SGB XI – Pflege + Betreuung',
    duration: '429 UE inkl. Praktikum',
    schedule: [
      'Mo–Fr · 09:00–13:00 Uhr',
      'Mo–Do · 18:00–20:00 Uhr (Abendkurs)',
      'Mo–Fr · 09:00–15:30 Uhr (Bildungsgutschein)',
    ],
    nextStart: 'Jeden Montag',
    weeks: '14 Wochen',
    price: '€ 3.490',
    funding: 'Nur mit Bildungsgutschein',
    audience: 'Einstieg in Pflege + Betreuung',
    description: 'Zwei Qualifikationen in einem Kurs: Pflegehilfskraft + Betreuungsassistent §43b/53c SGB XI. Du wirst doppelt einsetzbar und damit besonders gefragt – sowohl in der Grundpflege als auch in der sozialen Betreuung.',
    curriculum: [
      'Pflegerische Grundlagen (Grundpflege, Hygiene, Vitalzeichen)',
      'Betreuungsmodul §43b: Aktivierung & Tagesgestaltung',
      'Krankheitsbilder: Demenz, Depression, Apoplex',
      'Validation & Biographiearbeit',
      'Kommunikation, Konfliktmanagement',
      'Recht & Ethik in der Pflege und Betreuung',
      'Erste Hilfe & Notfallmaßnahmen',
      '40 Std. Praktikum',
    ],
    outcomes: [
      'Anerkennung als Pflegehilfskraft + Betreuungskraft nach §43b SGB XI',
      'Doppelqualifikation: vielseitiger Einsatz in Pflege & Betreuung',
      'Höhere Chancen auf Festanstellung',
    ],
  },
  {
    id: 'betreuungskraft',
    category: 'einstieg',
    title: 'Betreuungskraft §§43b, 53c SGB XI',
    subtitle: 'Alltagsgestaltung, soziale Betreuung & Aktivierung',
    duration: '40 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: '2 Wochen',
    price: '€ 900',
    funding: 'Direktbuchung',
    audience: 'Einstieg in Betreuung & Aktivierung',
    description: 'Werde Betreuungskraft nach §43b SGB XI und gib pflegebedürftigen Menschen das, was im Pflegealltag oft zu kurz kommt: Zeit, Zuwendung und Aktivierung. Eine sinnstiftende Tätigkeit mit klarer rechtlicher Grundlage.',
    curriculum: [
      'Rechtliche Grundlagen §43b/§53c SGB XI',
      'Krankheitsbilder: Demenz, Depression, gerontopsychiatrische Erkrankungen',
      'Aktivierungs- und Beschäftigungsangebote',
      'Biographiearbeit & Validation',
      'Kommunikation in der Betreuung',
      'Dokumentation der Betreuungsleistungen',
    ],
    outcomes: [
      'Anerkannte Qualifikation als Betreuungskraft',
      'Sofortiger Einstieg in stationäre oder ambulante Einrichtungen',
    ],
  },
  {
    id: 'grundlagen-betreuung',
    category: 'einstieg',
    title: 'Grundlagen der Betreuung & Alltagsbegleitung',
    subtitle: 'Kompakteinstieg für niedrigschwellige Betreuung',
    duration: '24 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: '1 Woche',
    price: '€ 490',
    funding: 'Direktbuchung',
    audience: 'Schneller Einstieg',
    description: 'Ein kompakter Einstieg für alle, die in der Alltagsbegleitung tätig werden möchten – z. B. ehrenamtlich oder als Selbstständige in niedrigschwelligen Betreuungsangeboten.',
    curriculum: [
      'Grundlagen der Alltagsbegleitung',
      'Erste Hilfe Update',
      'Hygiene-Grundlagen',
      'Kommunikation mit älteren Menschen',
      'Aktivierungs-Ideen für den Alltag',
    ],
    outcomes: [
      'Teilnahmebescheinigung',
      'Einstieg in niedrigschwellige Betreuung möglich',
    ],
  },
  {
    id: 'deutsch-pflegehelfer',
    category: 'einstieg',
    title: 'Berufsspezifisches Deutsch für Pflegehelfer',
    subtitle: 'Sprachliche & inhaltliche Vorbereitung auf den Pflegealltag',
    duration: '156 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: 'ca. 8 Wochen',
    price: '€ 1.900',
    funding: 'Direktbuchung',
    audience: 'Einstieg – internationale Pflegekräfte',
    description: 'Speziell für internationale Pflegekräfte: Lerne den deutschen Pflegealltag mit dem passenden Wortschatz – damit du am ersten Arbeitstag sicher kommunizierst.',
    curriculum: [
      'Fachwortschatz Pflege (Körperteile, Medikamente, Symptome)',
      'Übergabegespräche & Dienstplan',
      'Dokumentation auf Deutsch',
      'Telefonate mit Ärzten & Angehörigen',
      'Kulturelle Kompetenz im deutschen Gesundheitssystem',
      'Prüfungsvorbereitung B2 Pflege',
    ],
    outcomes: [
      'Sprachlich fit für den Pflegealltag in Deutschland',
      'Vorbereitung auf B2-Pflege-Prüfung',
    ],
  },

  // ERFAHREN
  {
    id: 'palliativ-care',
    category: 'erfahren',
    title: 'Weiterbildung Palliativ-Care',
    subtitle: 'Begleitung bei lebensbegrenzenden Erkrankungen',
    duration: '120 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: 'ca. 6 Wochen',
    price: '€ 1.950',
    funding: 'Direktbuchung',
    audience: 'Examinierte Pflegefachkräfte (3-jährige Ausbildung)',
    description: 'Begleite Menschen in ihrer letzten Lebensphase mit fachlicher und menschlicher Kompetenz. Diese Weiterbildung qualifiziert dich für eine der wertvollsten Aufgaben in der Pflege.',
    curriculum: [
      'Grundlagen der Palliativmedizin & Palliative Care',
      'Schmerz- und Symptomkontrolle',
      'Pflege Sterbender: Mund-, Haut-, Wundpflege',
      'Kommunikation mit Sterbenden und Angehörigen',
      'Ethik, Spiritualität, kulturelle Aspekte',
      'Trauerbegleitung & Selbstfürsorge',
      'Rechtliche Grundlagen (Patientenverfügung)',
    ],
    outcomes: [
      'Zertifikat Palliative Care (160 Std. mit Selbststudium möglich)',
      'Qualifikation für Hospiz- & Palliativdienste',
    ],
  },
  {
    id: 'pflegeassistent-lg1-lg2',
    category: 'erfahren',
    title: 'Pflegeassistenz nach LG1 & LG2',
    subtitle: 'Qualifikation in der Behandlungspflege (Rahmenvertrag NRW)',
    duration: '208 UE',
    schedule: [
      'Mo–Fr · 09:00–13:00 Uhr',
      'Mo–Do · 18:00–20:00 Uhr (Abendkurs)',
      'Mo–Fr · 09:00–15:30 Uhr (Bildungsgutschein)',
    ],
    nextStart: 'Jeden Montag',
    weeks: '6,5 Wochen',
    price: '€ 1.499',
    funding: 'Bildungsgutschein möglich',
    audience: 'Pflegehilfskräfte mit Berufserfahrung und Pflege-Grundqualifikation',
    description: 'Die Weiterqualifikation, die deinen Arbeitgeber begeistert: Mit LG1 + LG2 darfst du Behandlungspflege durchführen und deutlich mehr Leistungen abrechnen. Voraussetzung: Pflege-Grundqualifikation.',
    curriculum: [
      'LG1: Medikamentengabe (Richten und Verabreichen von verordneten Medikamenten)',
      'LG1: Blutzuckermessung (Durchführung und Protokollierung der Werte)',
      'LG1: Subkutane Injektionen (Spritzen in das Unterhautfettgewebe, z. B. Insulin oder Thrombosespritzen)',
      'LG1: Blutdruckmessung (Messen und Dokumentieren der Vitalwerte)',
      'LG1: Kompressionsstrümpfe (An- und Ausziehen ab Kompressionsklasse 1 oder Anlegen von Kompressionsverbänden)',
      'LG2: Wundversorgung (Dekubitus bis Grad 2)',
      'LG2: Katheter- und Sondenpflege (suprapubische Blasenkatheter SPK, PEG-Magensonden inkl. Nahrungsgabe)',
      'LG2: Ausscheidungshilfe (Klysmen, Klistieren, Einläufe)',
      'LG2: Flüssigkeitsbilanzierung (Dokumentation und Überwachung von Aufnahme und Abgabe)',
      'LG2: Spezielle lokale Therapien (medizinische Einreibungen, dermatologische Bäder)',
      'Rechtliche Grundlagen & Delegationsrahmen',
      'Dokumentation & Qualitätsmanagement',
    ],
    outcomes: [
      'Anerkennung nach Landesrahmenvertrag NRW',
      'Behandlungspflege LG1 + LG2 abrechenbar',
      'Mehr Verantwortung & besseres Gehalt',
    ],
  },
  {
    id: 'wundexperte',
    category: 'erfahren',
    title: 'Wundexperte',
    subtitle: 'Zertifizierte Wundversorgung in der Pflegepraxis',
    duration: '84 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: 'ca. 5 Wochen',
    price: '€ 1.690',
    funding: 'Direktbuchung',
    audience: '3-jährig examinierte Pflegefachkräfte, MFA, OTA, Podolog:innen u. a. (ICW-Zulassung)',
    description: 'Der zertifizierte Einstieg in die professionelle Wundversorgung. Du lernst alles, was du brauchst, um Wunden sicher zu beurteilen, zu versorgen und zu dokumentieren – nach aktuellen Standards der Wundtherapie.',
    curriculum: [
      'Wundphysiologie & Wundheilung',
      'Akute & chronische Wunden',
      'Dekubitus: Prophylaxe & Therapie',
      'Ulcus cruris venosum/arteriosum',
      'Diabetisches Fußsyndrom',
      'Moderne Wundauflagen & Verbandstoffe',
      'Wunddokumentation & Fotodokumentation',
      'Schmerzmanagement bei Wunden',
    ],
    outcomes: [
      'Zertifizierter Wundexperte (Dickies-Campus)',
      'Sichere Versorgung in Pflegedienst, Heim und Klinik',
    ],
  },
  {
    id: 'wundtherapeut',
    category: 'erfahren',
    title: 'Wundtherapeut',
    subtitle: 'Aufbau-Qualifikation für komplexe & chronische Wunden',
    duration: '120 UE + 40 Std. Hospitation',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: 'ca. 9 Wochen',
    price: '€ 2.390',
    funding: 'Direktbuchung',
    audience: 'Voraussetzung: abgeschlossene Weiterbildung zum Wundexperten (z. B. bei Dickies-Campus)',
    description: 'Die Aufbau-Qualifikation für die anspruchsvollsten Fälle: chronische, komplexe und interdisziplinär behandelte Wunden. Vertiefung in Diagnostik, Therapieplanung und Fallführung. Voraussetzung für die Teilnahme ist eine abgeschlossene Weiterbildung zum Wundexperten.',
    curriculum: [
      'Vertiefte Wundphysiologie & Diagnostik',
      'Komplexe Wundsituationen & seltene Wundbilder',
      'Therapieplanung & Fallführung',
      'Interdisziplinäre Versorgungskonzepte',
      'Onkologische & exulzerierende Wunden',
      'Pädiatrische Wundversorgung',
      'Hospitation im Wundzentrum',
      'Eigene Fallarbeit & Abschluss-Kolloquium',
    ],
    outcomes: [
      'Zertifizierter Wundtherapeut (Dickies-Campus)',
      'Stelle als Wundmanager:in / Wundberater:in möglich',
    ],
  },
  {
    id: 'chronische-wunden-pflegefachkraefte',
    category: 'erfahren',
    title: 'Chronisch- und schwerheilende Wunden',
    subtitle: 'Fachkurs Wundversorgung für Pflegefachkräfte',
    duration: '84 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: 'ca. 5 Wochen',
    price: '€ 1.250',
    funding: 'Direktbuchung',
    audience: 'Pflegefachkräfte',
    description: 'Der Fachkurs für die Versorgung chronischer und schwerheilender Wunden: Von der Physiologie der Wundheilung über gefäßbedingte Erkrankungen bis zu Kompressionstherapie, Schmerzmanagement und MD-sicherer Dokumentation.',
    curriculum: [
      'Physiologie & Anatomie der Haut, Wundheilung',
      'Wundarten, Wundassessment nach TIME',
      'Gefäßbedingte Erkrankungen: Ulcus cruris, PAVK, Lymphangiopathien',
      'Diabetisches Fußsyndrom & Dekubitus',
      'Wundbehandlungsprozess & moderne Wundauflagen',
      'Kompressionstherapie & Schmerzmanagement',
      'Ernährung, Dokumentation & Qualitätssicherung',
      'Kommunikation & Beratung im Pflegekontext',
    ],
    outcomes: [
      'Zertifikat Chronische Wundversorgung (Dickies-Campus)',
      'Sichere Versorgung chronischer Wunden nach Expertenstandard',
    ],
  },
  {
    id: 'chronische-wunden-leitung',
    category: 'fuehrung',
    title: 'Chronische Wunden für Leitungen',
    subtitle: 'Wundmanagement als Führungsaufgabe – Recht, QM, Wirtschaftlichkeit',
    duration: '84 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: 'ca. 5 Wochen',
    price: '€ 1.250',
    funding: 'Direktbuchung',
    audience: 'PDL, Einrichtungsleitung, QM-Beauftragte',
    description: 'Wundmanagement aus Leitungsperspektive: rechtssichere Delegation, Haftung, Expertenstandard-Umsetzung, Qualitätsmanagement und Wirtschaftlichkeit – bis zum fertigen internen Wundmanagement-Konzept für deine Einrichtung.',
    curriculum: [
      'Grundlagen des modernen Wundmanagements',
      'Rechtliche Grundlagen und Haftung',
      'Verantwortlichkeiten und Delegation',
      'Qualitätsmanagement & Expertenstandard chronische Wunden',
      'Wirtschaftlichkeit & Abrechnung',
      'Führungsaufgaben & interdisziplinäre Wundkonferenzen',
      'Dokumentation und Informationsmanagement',
      'Aufbau eines internen Wundmanagement-Gesamtkonzepts',
    ],
    outcomes: [
      'Zertifikat Wundmanagement für Leitungen (Dickies-Campus)',
      'Fertiges Konzept für das interne Wundmanagement',
      'MD-sichere Delegations- und Dokumentationsstruktur',
    ],
  },
  {
    id: 'intensivpflege-basiskurs',
    category: 'erfahren',
    title: 'Basiskurs Außerklinische Intensivpflege',
    subtitle: 'Nach §132l SGB V – der Einstieg in die Intensivpflege zu Hause',
    duration: '106 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: 'ca. 6 Wochen',
    price: '€ 1.250',
    funding: 'Direktbuchung',
    audience: 'Pflegefachkräfte',
    description: 'Der Basiskurs nach §132l SGB V für den Einstieg in die außerklinische Intensivpflege: von Atemwegsmanagement und Beatmungs-Grundlagen über Monitoring und Infusionstherapie bis zum sicheren Umgang mit Notfällen in der 1:1-Versorgung.',
    curriculum: [
      'Grundlagen der Intensivpflege',
      'Atmung und Atemwegsmanagement',
      'Grundlagen der Beatmung',
      'Herz-Kreislauf und Monitoring',
      'Zugänge und Infusionstherapie',
      'Medikamente in der Intensivversorgung',
      'Neurologische Überwachung',
      'Niere, Flüssigkeit und Ernährung',
    ],
    outcomes: [
      'Zertifikat Basiskurs Außerklinische Intensivpflege nach §132l SGB V (Dickies-Campus)',
      'Einstieg in Intensiv-WGs und Heimbeatmung – Aufbau zum Expertenkurs möglich',
    ],
  },
  {
    id: 'intensivpflege-experte',
    category: 'erfahren',
    title: 'Expertenkurs Außerklinische Intensivpflege',
    subtitle: 'Beatmung, Trachealkanüle & Notfallmanagement – sicher zu Hause versorgen',
    duration: '140 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: 'ca. 8 Wochen',
    price: '€ 2.390',
    funding: 'Direktbuchung',
    audience: 'Pflegefachkräfte',
    description: 'Der Expertenkurs für die außerklinische Intensivpflege: Beatmung, Trachealkanülenmanagement, Notfallsituationen und die rechtssichere 1:1-Versorgung – für den Einsatz in Intensiv-WGs und der Heimbeatmung.',
    curriculum: [
      'Rechtliche Grundlagen der außerklinischen Intensivpflege',
      'Anatomie, Physiologie & Krankheitslehre',
      'Beatmung: Grundlagen, Formen, Gerätekunde',
      'Tracheostoma & Trachealkanülenmanagement',
      'Notfallmanagement in der 1:1-Versorgung',
      'Ernährung, Ausscheidung & Hygiene',
      'Kommunikation mit Klienten & Angehörigen',
      'Palliative Versorgung & Ethik',
    ],
    outcomes: [
      'Zertifikat Experte Außerklinische Intensivpflege (Dickies-Campus)',
      'Einsatz in Intensiv-WGs, Heimbeatmung & 1:1-Versorgung',
    ],
  },
  {
    id: 'hygienebeauftragter',
    category: 'erfahren',
    title: 'Hygienebeauftragte:r in der Pflege',
    subtitle: 'Die anerkannte Zusatzqualifikation für Einrichtungen & Pflegedienste',
    duration: '80 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: 'ca. 5 Wochen',
    price: '€ 990',
    funding: 'Direktbuchung',
    audience: 'Pflegefachkräfte',
    description: 'Jede Einrichtung braucht sie: Hygienebeauftragte sichern die Einhaltung der KRINKO-Richtlinien, schulen Kolleg:innen und bestehen jede Hygiene-Begehung. Die komplette Zusatzqualifikation mit 80 UE.',
    curriculum: [
      'Mikrobiologie & Infektionslehre',
      'Gesetze, Richtlinien & KRINKO-Empfehlungen',
      'Qualitätsmanagement in der Hygiene',
      'Personalhygiene & Schutzausrüstung',
      'Haut-, Schleimhaut- und Wundantiseptik',
      'Betriebshygiene & Aufbereitung von Medizinprodukten',
      'Hygienepläne erstellen & Begehungen bestehen',
      'Schulung & Unterweisung der Mitarbeitenden',
    ],
    outcomes: [
      'Zertifikat Hygienebeauftragte:r in der Pflege (Dickies-Campus)',
      'Sichere Hygiene-Begehungen & MD-Prüfungen',
    ],
  },
  {
    id: 'qm-beauftragter',
    category: 'fuehrung',
    title: 'QM-Beauftragte:r im Gesundheitswesen',
    subtitle: 'Qualitätsmanagement nach ISO 9001 & DIN EN 15224',
    duration: '260 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: 'ca. 13 Wochen',
    price: '€ 1.490',
    funding: 'Direktbuchung',
    audience: 'Pflegefachkräfte & Leitungen',
    description: 'Die Weiterbildung zum/zur Qualitätsmanagementbeauftragten im Gesundheitswesen: von ISO 9001 und DIN EN 15224 über Risikomanagement und Patientensicherheit bis zum internen Audit – die Schlüsselrolle in jeder Einrichtung.',
    curriculum: [
      'DIN EN 15224 & ISO 9001 im Gesundheitswesen',
      'Recht, Aufsicht & Ethik',
      'Pflegeprozess & DNQP-Expertenstandards',
      'Klinisches Risikomanagement & Patientensicherheit',
      'Hygiene, Infektionsprävention & Notfallmanagement',
      'Management- und Qualitätswerkzeuge',
      'Internes Audit & Zertifizierungsvorbereitung',
      'QM-Dokumentation & Kennzahlen',
    ],
    outcomes: [
      'Zertifikat QM-Beauftragte:r im Gesundheitswesen (Dickies-Campus)',
      'Schlüsselqualifikation für QM-Stellen & Leitungsfunktionen',
    ],
  },
  {
    id: 'pflegefachassistent-externenpruefung',
    category: 'erfahren',
    title: 'Externenprüfung Pflegefachassistenz',
    subtitle: 'Vorbereitungskurs auf die staatliche Externenprüfung (NRW)',
    duration: '300 UE',
    schedule: [
      'Mo–Fr · 09:00–11:00 Uhr (Vormittag, berufsbegleitend)',
      'Mo–Do · 18:00–20:00 Uhr (Abendkurs)',
    ],
    nextStart: 'Jeden Montag',
    weeks: 'Individuell · in deinem Tempo (berufsbegleitend)',
    price: '€ 2.490',
    priceNote: 'Kursgebühr 1.990 € zzgl. 500 € Prüfungsgebühr der Prüfstelle — Gesamtpreis 2.490 €',
    funding: 'Direktbuchung · AZAV-Zulassung in Vorbereitung',
    audience: 'Pflegehilfskräfte mit Berufserfahrung – mind. 30 Monate Vollzeit (oder 60 Monate ab 50 % Teilzeit) in der Pflegehilfe/Pflegeassistenz, davon mind. die Hälfte unter Anleitung einer dreijährig examinierten Pflegefachkraft. Tätigkeit darf bei Antragstellung nicht länger als 24 Monate zurückliegen. Hauptschulabschluss Klasse 9 oder abgeschlossene Berufsausbildung erforderlich.',
    description: 'Der gezielte Vorbereitungskurs auf die externe Pflegefachassistenz-Prüfung in NRW. In 14 strukturierten Modulen bringen wir dich sicher zur Prüfung — berufsbegleitend, in deinem Tempo, praxisnah und mit echter Prüfungssimulation. Du steigst auf zur staatlich anerkannten Pflegefachassistenz, mehr Verantwortung, besseres Gehalt und eine fundierte Basis für die spätere generalistische Pflegefach-Ausbildung. Preis: 1.990 € Kursgebühr zzgl. 500 € Prüfungsgebühr — Gesamtpreis 2.490 €. Die Prüfungsgebühr wird von der Prüfstelle erhoben, 1:1 an dich weitergegeben und ist im Gesamtpreis bereits enthalten.',
    curriculum: [
      'Modul 1 · Berufliches Selbstverständnis und rechtliche Grundlagen (20 UE)',
      'Modul 2 · Pflegeprozess und Pflegedokumentation (25 UE)',
      'Modul 3 · Kommunikation und Beziehungsgestaltung (20 UE)',
      'Modul 4 · Anatomie, Physiologie und Krankheitslehre (40 UE)',
      'Modul 5 · Grundpflege und Unterstützung bei Aktivitäten des täglichen Lebens (45 UE)',
      'Modul 6 · Behandlungspflege im Aufgabenbereich der Pflegefachassistenz (35 UE)',
      'Modul 7 · Hygiene und Infektionsprävention (15 UE)',
      'Modul 8 · Ernährung, Ausscheidung und Mobilität (20 UE)',
      'Modul 9 · Menschen aller Altersgruppen pflegen (20 UE)',
      'Modul 10 · Notfallsituationen und Erste Hilfe (10 UE)',
      'Modul 11 · Palliative Versorgung und Sterbebegleitung (10 UE)',
      'Modul 12 · Praktische Prüfungsvorbereitung (20 UE)',
      'Modul 13 · Schriftliche Prüfungsvorbereitung (10 UE)',
      'Modul 14 · Mündliche Prüfungsvorbereitung (10 UE)',
    ],
    outcomes: [
      'Vollständige Vorbereitung auf die staatliche Externenprüfung Pflegefachassistenz (NRW)',
      'Aufstieg zur staatlich anerkannten Pflegefachassistenz – mehr Verantwortung, besseres Gehalt',
      'Solide Basis für die generalistische Pflegefach-Ausbildung (verkürzbar nach Externenprüfung)',
      'Realistische Prüfungssimulation: schriftlich, praktisch & mündlich',
    ],
  },
  {
    id: 'pflegefachexpertin',
    category: 'erfahren',
    title: 'Pflegefachexpertin',
    subtitle: 'Strukturierte 24-Monats-Weiterbildung zur fachlichen Ansprechpartnerin im Team',
    duration: '1.800 UE',
    schedule: [
      'Berufsbegleitend · Selbststudium + Praxisaufgaben',
      'Eingestreute Online-Präsenz-Termine nach vorheriger Absprache',
    ],
    nextStart: 'Jeden Montag',
    weeks: 'ca. 24 Monate (berufsbegleitend)',
    price: '€ 5.990',
    funding: 'Direktbuchung · Ratenzahlung möglich · AZAV-Zulassung in Vorbereitung',
    audience: 'Pflegefachkräfte ODER LG1/LG2-Kräfte mit mind. 3 Jahren Berufserfahrung. Empfohlen für Pflegekräfte, die innerhalb ihres Teams als fachliche Ansprechpartnerin auftreten möchten — ohne den klassischen Führungs-Aufstieg zur PDL.',
    description: 'Die strukturierte 24-Monats-Weiterbildung zur Pflegefachexpertin macht aus erfahrenen Pflegekräften die fachlichen Ansprechpartnerinnen ihres Teams. 14 Schwerpunkt-Module bringen Krankheitslehre, Pharmakologie, Wundversorgung, Palliativ, Demenz, Notfall, Hygiene, Expertenstandards, Qualitätsmanagement, Kommunikation, Pflegewissenschaft, Versorgungsmanagement und Digitalisierung in einen klaren Lernpfad. Abgeschlossen mit Facharbeit, Praxisprojekt und Abschlusskolloquium — als Titel-tragende Qualifikation für Arbeitgeber und Bewerbungen.',
    curriculum: [
      'Schwerpunkt 1 · Erweiterte Krankheitslehre',
      'Schwerpunkt 2 · Anatomie und Physiologie',
      'Schwerpunkt 3 · Pharmakologie',
      'Schwerpunkt 4 · Wundversorgung',
      'Schwerpunkt 5 · Palliativversorgung',
      'Schwerpunkt 6 · Demenz und Gerontopsychiatrie',
      'Schwerpunkt 7 · Notfallmanagement',
      'Schwerpunkt 8 · Hygiene und Infektionsschutz',
      'Schwerpunkt 9 · Pflegeprozess und Expertenstandards',
      'Schwerpunkt 10 · Qualitätsmanagement',
      'Schwerpunkt 11 · Kommunikation und Beratung',
      'Schwerpunkt 12 · Pflegewissenschaft',
      'Schwerpunkt 13 · Versorgungsmanagement',
      'Schwerpunkt 14 · Digitalisierung in der Pflege',
      'Abschluss · Facharbeit (schriftliche Ausarbeitung)',
      'Abschluss · Praxisprojekt im eigenen Arbeitsfeld',
      'Abschluss · Mündliches Abschlusskolloquium',
    ],
    outcomes: [
      'Titel-tragende Qualifikation „Pflegefachexpertin" — anerkannt von Arbeitgebern',
      'Fachliche Ansprechpartnerin im Team (Brücke zwischen PFK und PDL)',
      'Mehr Verantwortung, höheres Gehalt — ohne klassischen Führungs-Aufstieg',
      'Basis für weitere Spezialisierungen (Wundexperte, Praxisanleiter, etc.)',
    ],
  },
  {
    id: 'gerontopsychiatrische-fachweiterbildung',
    category: 'erfahren',
    title: 'Gerontopsychiatrische Fachweiterbildung',
    subtitle: 'Demenz, Depression & herausforderndes Verhalten professionell begleiten',
    duration: '720 UE',
    schedule: 'Online im eigenen Tempo · Start jederzeit',
    format: 'E-Learning · 35 Kapitel online · Einsendeaufgaben mit persönlichem Feedback',
    flexible: true,
    nextStart: 'Jederzeit – Start nach Anmeldung & Freischaltung',
    weeks: 'Flexibel im eigenen Tempo',
    price: '€ 3.990',
    funding: 'Direktbuchung · Förderung durch Arbeitgeber häufig möglich',
    audience: 'Examinierte Pflegefachkräfte (3-jährige Ausbildung) in ambulanter Pflege, Tagespflege und stationären Einrichtungen, die gerontopsychiatrische Fachkompetenz aufbauen und Verantwortung übernehmen möchten',
    description: 'Die große Fachweiterbildung für den Umgang mit gerontopsychiatrisch veränderten Menschen: Demenz, Depression, Delir und herausforderndes Verhalten sicher erkennen und professionell begleiten. Alle 35 Kapitel stehen online bereit – du lernst flexibel im eigenen Tempo, interaktiv mit Fallszenarien, Zuordnungsübungen und Wissenstests. Deine Einsendeaufgaben werden individuell gelesen und mit persönlichem Feedback beantwortet.',
    curriculum: [
      'Demenz – Formen, Verlauf und Begleitung',
      'Depression, Angst und Suizidalität im Alter',
      'Delir und akute Verwirrtheit erkennen',
      'Validation nach Naomi Feil & Biografiearbeit',
      'Milieutherapie und Wohnraumgestaltung',
      'Umgang mit herausforderndem Verhalten',
      'Kommunikation und Beziehungsgestaltung',
      'Angehörigenarbeit und Beratung',
      'Recht & Ethik – Betreuung, FeM, Zwang',
      'Pharmakotherapie im Alter sicher begleiten',
      'Musik-, Kunst- und Aromatherapie',
      'End-of-Life-Care bei Demenz',
    ],
    outcomes: [
      'Anerkanntes Zertifikat mit Echtheitsprüfung per Barcode',
      'Gerontopsychiatrische Fachkompetenz für Demenz, Depression & Delir',
      'Mehr Sicherheit und Verantwortung in der Versorgung gerontopsychiatrisch veränderter Menschen',
    ],
  },

  // FÜHRUNG
  {
    id: 'pdl',
    category: 'fuehrung',
    title: 'Pflegedienstleitung (PDL)',
    subtitle: 'Organisation, Personalführung, Qualität, Wirtschaftlichkeit',
    duration: '720 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: 'ca. 36 Wochen',
    price: '€ 4.690',
    funding: 'Direktbuchung',
    audience: 'Führungskräfte',
    description: 'Die anerkannte 720-Stunden-Weiterbildung zur Pflegedienstleitung – ideal für erfahrene Pflegefachkräfte, die in die Führung möchten. Du lernst alles, was du als PDL eines Pflegedienstes oder einer Einrichtung wirklich brauchst.',
    curriculum: [
      'Pflegemanagement & Organisation',
      'Personalführung & Personalentwicklung',
      'Qualitätsmanagement nach MD-Anforderungen',
      'Wirtschaftliche Steuerung & Pflegebuchhaltung',
      'Pflegeplanung & Pflegeprozess',
      'Recht: SGB XI, Heimrecht, Arbeitsrecht',
      'Pflegegrade & MD-Begutachtung',
      'Hygienemanagement',
      'Konfliktmanagement & Kommunikation',
      'Praxisprojekte aus dem PDL-Alltag',
    ],
    outcomes: [
      'Anerkannter Abschluss als Pflegedienstleitung',
      'Voraussetzung für die Stelle als PDL',
      'Deutlich besseres Gehalt & Führungsverantwortung',
    ],
  },
  {
    id: 'praxisanleitung',
    category: 'fuehrung',
    title: 'Praxisanleitung',
    subtitle: 'Praktische Ausbildung von Auszubildenden (PflAPrV §4 Abs. 3)',
    duration: '300 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: 'ca. 16 Wochen',
    price: '€ 2.499',
    funding: 'Direktbuchung',
    audience: 'Anleitende Pflegefachkräfte',
    description: 'Werde berufspädagogische Praxisanleiterin und bilde die Pflegekräfte von morgen aus. Eine gesetzlich vorgeschriebene Qualifikation für alle, die Auszubildende anleiten.',
    curriculum: [
      'Berufspädagogische Grundlagen',
      'Anleitungsmethoden in der Praxis',
      'Lernziele formulieren & Lernprozesse begleiten',
      'Reflexion, Feedback & Beurteilung',
      'Generation Z im Lernkontext',
      'Rechtliche Grundlagen (PflAPrV §4 Abs. 3)',
      'Prüfungsvorbereitung & Prüfungsabnahme',
    ],
    outcomes: [
      'Zertifikat als Praxisanleitung gem. PflAPrV',
      'Zulassung zur Ausbildung von Pflege-Azubis',
      'Pflichtweiterbildung 24 UE/Jahr (von uns angeboten)',
    ],
  },
  {
    id: 'pflegeberater',
    category: 'fuehrung',
    title: 'Pflegeberater nach §7a SGB XI',
    subtitle: 'Bedarfsanalyse, Versorgungspläne, Systemnavigation',
    duration: '480 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: 'ca. 23 Wochen',
    price: '€ 2.990',
    funding: 'Direktbuchung',
    audience: 'Beratung & Care-Management',
    description: 'Pflegeberater nach §7a SGB XI sind die zentralen Lotsen für Pflegebedürftige und Angehörige. Du hilfst Menschen, sich im komplexen Pflegesystem zurechtzufinden – eine sinnstiftende Tätigkeit mit großer Wirkung.',
    curriculum: [
      'Pflegeberatungsprozess nach §7a SGB XI',
      'Sozialgesetzbuch SGB XI im Überblick',
      'Pflegegrade & MD-Begutachtung',
      'Versorgungsplanung & Case Management',
      'Kommunikation in Beratungssituationen',
      'Selbsthilfe-Netzwerke & soziale Dienste',
      'Beratung bei demenziellen Erkrankungen',
    ],
    outcomes: [
      'Anerkannter Pflegeberater nach §7a SGB XI',
      'Einsatz bei Krankenkassen, kommunalen Stellen oder freiberuflich',
    ],
  },
  {
    id: 'pflege-ki-fuehrerschein',
    category: 'fuehrung',
    title: 'Pflege-KI Führerschein',
    subtitle: 'KI-gestützte Pflegedokumentation — inkl. 6 Monate Pflege-KI Kompakt',
    duration: '8 Module E-Learning + 6 Monate Software-Zugang',
    schedule: [
      'E-Learning · sofort starten, im eigenen Tempo',
      'Zugang zu Kurs & Pflege-KI direkt nach Buchung per E-Mail',
    ],
    nextStart: 'Sofort nach Buchung',
    weeks: 'Selbstlerntempo',
    price: '€ 1.990',
    funding: 'Direktbuchung · inkl. 6 Monate Pflege-KI Kompakt (Wert 1.194 €)',
    audience: 'PDLs, Praxisanleitungen & Pflegekräfte, die die Doku digitalisieren wollen',
    description: 'Der E-Learning-Kurs, der dein Team fit für die KI-Dokumentation macht: diktieren statt tippen, SIS & Maßnahmenplan auf Knopfdruck, MD-Prüfung vorab simulieren. Du absolvierst die 8 Module in deinem Tempo — und arbeitest parallel direkt in der echten Software: 6 Monate voller Zugang zur Pflege-KI Kompakt (1 PDL + bis zu 10 Mitarbeiter) sind im Kurspreis enthalten und werden sofort nach Buchung automatisch freigeschaltet.',
    curriculum: [
      'Modul 1 · Warum KI in der Pflege-Doku? Rechtslage, MD-Prüfung & Halluzinationsschutz',
      'Modul 2 · Die digitale Patientenmappe: alle 12 Sektionen sicher anlegen & pflegen',
      'Modul 3 · Diktieren wie ein Profi: Whisper-Spracheingabe am Patientenbett',
      'Modul 4 · Die perfekte SIS mit KI: vom Diktat zur strukturierten SIS (TF 1–6)',
      'Modul 5 · Maßnahmenplan & Risikomatrix: Vorschläge prüfen & übernehmen',
      'Modul 6 · Pflegegrad & Höherstufung: NBA-Analyse, Tendenz & Kassenbrief',
      'Modul 7 · Die MD-Prüfung bestehen: QPR-26, MD-Simulator & Cross-Doc-Plausi',
      'Modul 8 · Führen mit Daten: Freigaben, Team-Verwaltung, Wochen- & Monatsreport',
    ],
    outcomes: [
      'Zertifikat „Pflege-KI Führerschein" für dich & dein Team',
      '6 Monate Pflege-KI Kompakt inklusive (bis zu 10 Mitarbeiter-Zugänge)',
      'Erstaufnahme in 25 statt 120 Minuten — MD-sicher dokumentiert',
    ],
  },

  // PFLICHTFORTBILDUNGEN
  {
    id: 'rezert-betreuungskraft',
    category: 'pflicht',
    title: 'Betreuungskraft §43b SGB XI – Rezertifizierung',
    subtitle: 'Jährlich gesetzlich verpflichtend',
    duration: '24 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Nächster Termin – auf Anfrage',
    weeks: '3 Tage',
    price: '€ 290',
    funding: 'Direktbuchung',
    audience: 'Betreuungskräfte',
    description: 'Die gesetzlich vorgeschriebene jährliche Pflicht-Rezertifizierung für Betreuungskräfte nach §43b SGB XI – kompakt an zwei Samstagen.',
    curriculum: [
      'Update Gesetzeslage SGB XI',
      'Demenz: aktuelle Erkenntnisse',
      'Praxisreflexion & Fallbesprechungen',
      'Kommunikation & Validation – Refresher',
    ],
    outcomes: [
      'MD-konforme Teilnahmebescheinigung',
      'Gesetzliche Anforderung erfüllt',
    ],
  },
  {
    id: 'rezert-wundmanagement',
    category: 'pflicht',
    title: 'Rezertifizierung Wundmanagement',
    subtitle: 'Jährliche Pflichtfortbildung für Wundexpert:innen',
    duration: '16 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Nächster Termin – auf Anfrage',
    weeks: '2 Tage',
    price: '€ 290',
    funding: 'Direktbuchung',
    audience: 'Wundexpert:innen & Pflegefachkräfte mit Wundqualifikation',
    description: 'Die jährliche Auffrischung für zertifizierte Wundexpert:innen: aktuelle Leitlinien, neue Wundauflagen, Dokumentation und Praxis-Update – kompakt und MD-sicher.',
    curriculum: [
      'Aktueller Stand der modernen Wundversorgung',
      'Fachgerechte Wundbeurteilung & Dokumentation',
      'Neue Wundauflagen – Marktübersicht',
      'Dekubitus, Ulcus cruris & Diabetisches Fußsyndrom – Update',
      'Infektionszeichen, Hygiene & Schmerzmanagement',
      'Aktuelle Leitlinien & Expertenstandard',
    ],
    outcomes: [
      'MD-konforme Teilnahmebescheinigung',
      'Zertifikat bleibt gültig – Rezertifizierung erfüllt',
    ],
  },
  {
    id: 'rezert-praxisanleitung',
    category: 'pflicht',
    title: 'Rezertifizierung Praxisanleitung',
    subtitle: 'Gem. PflAPrV §4 – mit Teilnahmebescheinigung',
    duration: '24 UE',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Jeden Montag',
    weeks: '1 Woche',
    price: '€ 450',
    funding: 'Direktbuchung',
    audience: 'Praxisanleitende',
    description: 'Praxisanleiter:innen müssen sich jährlich 24 UE fortbilden – dieser Kurs erfüllt diese Pflicht kompakt in einer Woche.',
    curriculum: [
      'Aktuelle Lehrmethoden in der Pflege',
      'Generation Z im Lernkontext',
      'Prüfungsvorbereitung & Prüfungsabnahme',
      'Reflexion eigener Anleitungspraxis',
      'Update PflAPrV',
    ],
    outcomes: [
      'Teilnahmebescheinigung gem. PflAPrV §4',
      'Pflicht-Fortbildung 24 UE erfüllt',
    ],
  },
  {
    id: 'paket-gross',
    category: 'pflicht',
    title: 'Paket Groß – Jährliche Pflichtfortbildungen',
    subtitle: 'Für Pflegepersonal, Betreuungskraft & Praxisanleitung – inkl. Rezertifizierungen',
    duration: '12 Monate Gültigkeit',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Sofort startbar',
    weeks: '1 Jahr · alle Mitarbeitenden',
    price: '€ 1.900 / Pflegedienst',
    funding: 'Komplettpreis · Online deutschlandweit',
    audience: 'Pflegedienste & Einrichtungen – ein Preis für den gesamten Pflegedienst',
    description: 'Das große Komplett-Paket für deinen Pflegedienst: Ein Festpreis pro Jahr für ALLE Mitarbeitenden – inklusive Rezertifizierung Praxisanleitung und Rezertifizierung Betreuungskraft §43b. Alle gesetzlichen Pflichtfortbildungen kompakt, nachweisbar und MD-konform dokumentiert.',
    curriculum: [
      'Hygiene & Infektionsprävention für alle Mitarbeitenden (8 UE · inkl. Skript)',
      'Gewaltprävention & Deeskalation (8 UE · inkl. Skript)',
      'Haftung, Verantwortung & Delegation (8 UE · inkl. Skript)',
      'Datenschutz nach DSGVO',
      'Brandschutz',
      'Erste Hilfe Update',
      'Arbeitsschutz & Unfallverhütung',
      'Expertenstandards (DNQP) – alle pflegerelevanten Standards',
      'Rezertifizierung Betreuungskraft §43b SGB XI (24 UE)',
      'Rezertifizierung Praxisanleitung gem. PflAPrV §4 (24 UE)',
      'Demenzsensible Pflege',
      'Schmerzmanagement',
      'Aktuelle Themen je nach Bedarf',
    ],
    outcomes: [
      'Alle gesetzlichen Pflichtfortbildungen für ein Jahr abgedeckt',
      'Inkl. Rezertifizierungen Praxisanleitung + Betreuungskraft',
      'Komplette Dokumentation, MD-konform',
      'Ein Preis für den gesamten Pflegedienst – keine Kosten pro Person',
    ],
  },
  {
    id: 'paket-klein',
    category: 'pflicht',
    title: 'Paket Klein – Jährliche Pflichtfortbildungen',
    subtitle: 'Grundsachen für alle Mitarbeitenden – Hygiene & Infektionsprävention',
    duration: '12 Monate Gültigkeit',
    schedule: 'Individuell mit Dozent:in abstimmbar',
    format: 'E-Learning Modul für Modul · ergänzt durch Live-Termine',
    flexible: true,
    nextStart: 'Sofort startbar',
    weeks: '1 Jahr · alle Mitarbeitenden',
    price: '€ 1.200 / Pflegedienst',
    funding: 'Komplettpreis · Online deutschlandweit',
    audience: 'Pflegedienste & Einrichtungen – ein Preis für den gesamten Pflegedienst',
    description: 'Die kompakte Variante: Ein Festpreis pro Jahr für ALLE Mitarbeitenden mit den grundlegenden gesetzlichen Pflichtfortbildungen. Ideal für Pflegedienste, die nur das gesetzliche Minimum abdecken möchten.',
    curriculum: [
      'Hygiene & Infektionsprävention (KRINKO-Standards) · 8 UE inkl. Skript',
      'Gewaltprävention & Deeskalation · 8 UE inkl. Skript',
      'Haftung, Verantwortung & Delegation · 8 UE inkl. Skript',
      'Persönliche Schutzausrüstung (PSA)',
      'Händedesinfektion & Flächendesinfektion',
      'Umgang mit MRE (multiresistente Erreger)',
      'Aktuelle Themen Pandemievorsorge',
    ],
    outcomes: [
      'Gesetzliche Hygiene-Pflichtfortbildung für ein Jahr abgedeckt',
      'MD-konforme Dokumentation für den gesamten Pflegedienst',
      'Ein Preis für alle Mitarbeitenden – keine Zusatzkosten pro Person',
    ],
  },
];

export const CATEGORY_LABELS = {
  einstieg: 'Einstieg',
  erfahren: 'Fachweiterbildung',
  fuehrung: 'Leitung & Führung',
  pflicht: 'Pflichtfortbildung',
};

// ── Karriere-Pfad (NRW) ──
// Stufen-Logik statt abstrakter Tabs: "Wo stehst du gerade?"
// Zulassungen NRW-geprüft: Wundexperte ICW, Palliative Care 160 UE, Praxisanleitung
// (PflAPrV §4), PDL (§71 SGB XI) setzen das 3-jährige Examen voraus.
export const CAREER_STAGES = [
  {
    id: 'start',
    num: '01',
    label: 'Ohne Vorerfahrung',
    short: 'Quereinstieg',
    requirement: 'Keine Voraussetzungen',
    description: 'Dein erster Schritt in die Pflege: Basisqualifikationen, mit denen du sofort arbeiten kannst – ohne Vorkenntnisse, Start jeden Montag.',
    courseIds: [
      'ambulanter-pflegeassistent',
      'pflegehelfer-qn2',
      'pflegehilfskraft-betreuung',
      'betreuungskraft',
      'grundlagen-betreuung',
      'deutsch-pflegehelfer',
    ],
  },
  {
    id: 'hilfskraft',
    num: '02',
    label: 'Pflegehilfskraft mit Erfahrung',
    short: 'Berufserfahren',
    requirement: 'Berufserfahrung in der Pflegehilfe',
    description: 'Du arbeitest schon in der Pflege? Diese Kurse bringen dich auf die nächste Stufe – von der Behandlungspflege bis zum staatlichen Examen.',
    courseIds: [
      'pflegeassistent-lg1-lg2',
      'pflegefachassistent-externenpruefung',
      'pflege-ki-fuehrerschein',
    ],
  },
  {
    id: 'pfa',
    num: '03',
    label: 'Pflegefachassistenz',
    short: 'Examiniert (1–2-jährig)',
    requirement: 'Staatliches Examen Pflegefachassistenz',
    description: 'Mit deinem Examen in der Tasche geht es strukturiert weiter – wir sagen dir ehrlich, was in NRW möglich ist.',
    note: 'Wichtig zu wissen: Die meisten Fachweiterbildungen (Wundexperte ICW, Palliative Care, Praxisanleitung, PDL) setzen in NRW das 3-jährige Examen voraus. Dein stärkster nächster Schritt ist die verkürzte generalistische Ausbildung zur Pflegefachkraft – wir beraten dich kostenlos zum Weg dahin.',
    courseIds: [
      'pflegefachexpertin',
      'pflege-ki-fuehrerschein',
    ],
  },
  {
    id: 'fachkraft',
    num: '04',
    label: 'Pflegefachkraft',
    short: 'Spezialisierung',
    requirement: '3-jähriges Examen',
    description: 'Spezialisiere dich mit aufeinander aufbauenden Fachweiterbildungen – z. B. erst Wundexperte, dann Wundtherapeut.',
    courseIds: [
      'wundexperte',
      'wundtherapeut',
      'chronische-wunden-pflegefachkraefte',
      'palliativ-care',
      'intensivpflege-basiskurs',
      'intensivpflege-experte',
      'hygienebeauftragter',
      'gerontopsychiatrische-fachweiterbildung',
      'praxisanleitung',
      'pflegefachexpertin',
    ],
  },
  {
    id: 'fuehrung',
    num: '05',
    label: 'Leitung & Führung',
    short: 'PDL, QM & Beratung',
    requirement: 'Pflegefachkraft mit Berufserfahrung',
    description: 'Vom Team in die Verantwortung: Leitungs-, QM- und Beratungsqualifikationen für den nächsten Karriereschritt.',
    courseIds: [
      'pdl',
      'qm-beauftragter',
      'chronische-wunden-leitung',
      'pflegeberater',
    ],
  },
  {
    id: 'pflicht',
    num: '06',
    label: 'Pflichtfortbildungen',
    short: 'Teams & Einrichtungen',
    requirement: 'Jährlich verpflichtend · MD-konform',
    description: 'Jahres-Pakete und Rezertifizierungen für deinen ganzen Pflegedienst – ein Festpreis, komplett dokumentiert.',
    courseIds: [
      'paket-gross',
      'paket-klein',
      'rezert-betreuungskraft',
      'rezert-wundmanagement',
      'rezert-praxisanleitung',
    ],
  },
];

// Offizielles Kursskript – für Kursteilnehmer kostenlos inklusive.
// Seitenzahlen bitte aktuell halten, wenn neue Skript-Versionen hinterlegt werden.
export const COURSE_SKRIPTE = {
  'ambulanter-pflegeassistent': {
    cover: '/ambulanter-pflegeassistent-cover.webp',
    title: 'Kursskript Ambulante Pflegeassistenz',
    pages: 775,
    paketWert: 199,
  },
  'pflegeassistent-lg1-lg2': {
    cover: '/behandlungspflege-lg1-lg2-cover.webp',
    title: 'Kursskript Behandlungspflege LG1 & LG2',
    pages: 694,
    paketWert: 199,
    amazonUrl: 'https://amzn.eu/d/0hDnoUOg',
    amazonPreis: '39,99',
  },
  'pflegefachassistent-externenpruefung': {
    cover: '/externenpruefung-pflegefachassistenz-cover.webp',
    title: 'Kursskript Externenprüfung Pflegefachassistenz',
    pages: 482,
    paketWert: 199,
    amazonUrl: 'https://www.amazon.de/dp/B0HPH6ZYX3',
    amazonPreis: '49,90',
  },
  'pflegehilfskraft-betreuung': {
    cover: '/pflegehilfskraft-betreuung-cover.webp',
    title: 'Kursskript Pflegehilfskraft mit Betreuung',
    pages: 471,
    paketWert: 199,
  },
  'palliativ-care': {
    cover: '/palliativpflege-cover.webp',
    title: 'Kursskript Weiterbildung Palliativpflege',
    pages: 552,
    paketWert: 199,
  },
  'wundexperte': {
    cover: '/wundexperte-cover.webp',
    title: 'Kursskript Weiterbildung Wundexperte',
    pages: 133,
    paketWert: 199,
  },
  'chronische-wunden-pflegefachkraefte': {
    cover: '/chronische-wunden-pflegefachkraefte-cover.webp',
    title: 'Kursskript Chronisch- und schwerheilende Wunden',
    pages: 117,
    paketWert: 199,
  },
  'chronische-wunden-leitung': {
    cover: '/chronische-wunden-leitung-cover.webp',
    title: 'Kursskript Chronische Wunden für Leitungen',
    pages: 118,
    paketWert: 199,
  },
  'rezert-betreuungskraft': {
    cover: '/rezert-betreuungskraefte-cover.webp',
    title: 'Kursskript Jährliche Rezertifizierung Betreuungskräfte §43b/§53b',
    pages: 101,
    paketWert: 199,
  },
  'rezert-wundmanagement': {
    cover: '/rezert-wundmanagement-cover.webp',
    title: 'Kursskript Jährliche Rezertifizierung Wundmanagement',
    pages: 101,
    paketWert: 199,
  },
  'intensivpflege-basiskurs': {
    cover: '/intensivpflege-basiskurs-cover.webp',
    title: 'Kursskript Basiskurs Außerklinische Intensivpflege',
    pages: 68,
    paketWert: 199,
  },
  'intensivpflege-experte': {
    cover: '/intensivpflege-experte-cover.webp',
    title: 'Kursskript Expertenkurs Außerklinische Intensivpflege',
    pages: 211,
    paketWert: 199,
  },
  'hygienebeauftragter': {
    cover: '/hygienebeauftragter-cover.webp',
    title: 'Kursskript Hygienebeauftragte:r in der Pflege',
    pages: 612,
    paketWert: 199,
  },
  'qm-beauftragter': {
    cover: '/qm-beauftragter-cover.webp',
    title: 'Kursskript QM-Beauftragte:r im Gesundheitswesen',
    pages: 182,
    paketWert: 199,
  },
  'wundtherapeut': {
    cover: '/wundtherapeut-cover.webp',
    title: 'Kursskript Weiterbildung Wundtherapeut:in',
    pages: 178,
    paketWert: 199,
  },
  'gerontopsychiatrische-fachweiterbildung': {
    cover: '/gerontopsychiatrie-cover.webp',
    title: 'Kursskript Gerontopsychiatrische Fachweiterbildung',
    pages: 388,
    paketWert: 199,
  },
  'pdl': {
    cover: '/pdl-weiterbildung-bundle-cover.webp',
    title: 'Kursskripte PDL – Teil 1 & Teil 2',
    pages: 1900,
    volumes: '2 Bände · 1.308 + 592 Seiten',
    paketWert: 249,
    amazonUrl: 'https://www.amazon.de/dp/B0HP6MCSKG',
    amazonPreis: '69,99',
  },
  'praxisanleitung': {
    cover: '/praxisanleitung-cover.webp',
    title: 'Kursskript Praxisanleitung',
    pages: 184,
    paketWert: 199,
    amazonUrl: 'https://www.amazon.de/dp/B0HPH72N36',
    amazonPreis: '39,90',
  },
  'pflegeberater': {
    cover: '/pflegeberater-7a-cover.webp',
    title: 'Kursskript Pflegeberater:in nach § 7a SGB XI',
    pages: 594,
    paketWert: 199,
    amazonUrl: 'https://www.amazon.de/dp/B0HQ6WD9ZT',
    amazonPreis: '49,90',
  },
};
